<script>
    import { createEventDispatcher, onDestroy, onMount } from "svelte";
    import AudioControls from "./AudioControls.svelte";
    import AudioIndicator from "./AudioIndicator.svelte";

    let dispatch = createEventDispatcher();
    let audioElement;
    export let audio;
    export let showBack;
    export let showNext;

    let isPlaying = false;

    $: if (audio) {
        loadAudio()
    }

    function loadAudio() {
        setTimeout(() => {
            audioElement.pause();
            audioElement.load();
            //audioElement.play();
        }, 100);
    }

    function toggleAudio() {
        if (audioElement.paused && !isPlaying) {
            return audioElement.play();
        }
        if (!audioElement.paused && isPlaying) {
            return audioElement.pause();
        }
    }

    function fastForward() {
        if (audioElement) {
            audioElement.currentTime += 15;
        }
    }

    function fastBack() {
        if (audioElement) {
            audioElement.currentTime -= 15;
        }
    }

    let currentTimeTracker;
    let currentTime;
    let currentDuration = 0;

    onMount(() => {
        audioElement.onplaying = () => {
            isPlaying = true;
        };
        audioElement.onpause = () => {
            isPlaying = false;
        };
        audioElement.onloadeddata = () => {
            currentDuration = audioElement.duration;
        };
        currentTimeTracker = setInterval(() => {
            currentTime = audioElement.currentTime;
        }, 10);
    });

    onDestroy(() => {
        clearInterval(currentTimeTracker);
    });
</script>

<audio preload="metadata" bind:this={audioElement}>
    <source src={audio} type="audio/mpeg" />
</audio>

<div style="padding-left: 16px; padding-right: 16px">
    <AudioIndicator {currentDuration} {currentTime} />
</div>

<AudioControls
    {showNext}
    {showBack}
    {isPlaying}
    on:playClicked={toggleAudio}
    on:fastForward={() => fastForward()}
    on:fastBack={() => fastBack()}
    on:switchForward={() => dispatch("switchForward")}
    on:switchBackwards={() => dispatch("switchBackwards")}
/>
